"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_isempty_1 = __importDefault(require("lodash.isempty"));

function isEmpty(entity) {
  return lodash_isempty_1.default(entity);
}

exports.isEmpty = isEmpty;